var React = require('react');

function Jupiter (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.625 5c-1.461 0-2.825.655-3.852 1.614-1.028.959-1.758 2.258-1.758 3.686 0 2.513 1.525 3.671 2.704 3.671v-1.92c.016 0-.784.076-.784-1.751 0-.742.431-1.614 1.147-2.283.717-.668 1.68-1.097 2.543-1.097.938 0 1.838.32 2.514 1.004.676.683 1.176 1.757 1.176 3.46 0 1.653-.674 3.952-1.993 5.736-1.318 1.784-3.188 3.067-5.766 3.067h-.581v1.92h12.409v4.466h1.92v-4.465h2.527v-1.92h-2.527V5.418h-1.92v14.77h-6.388a10.203 10.203 0 001.871-1.928c1.588-2.149 2.368-4.733 2.368-6.876 0-2.095-.663-3.732-1.731-4.812S14.01 5 12.625 5z"}));
}

Jupiter.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Jupiter;

Jupiter.default = Jupiter;
